export interface IServerErrorItem {
  code: string;
  key: string;
  message: string;
}

export interface IServerError {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  errors: (any | IServerErrorItem)[];
  message: string;
  statusCode?: number;
}

export function isResponseContainsKey<S extends object, E>(response: S | E, key: string): response is S {
  return key in (response as S);
}
